import {
  VlogPlaylistCard,
  VlogSectionHeading
} from "@modules/study/common/vlog";
import { Grid } from "@mui/material";
import PaginationComponent from "@unisearch/common/ui_element/pagination";
import { useRouter } from "next/router";
import { Fragment, useEffect, useState } from "react";

const links = [
  {
    title: "Home",
    link: "/",
  },
  {
    title: "Vlog",
    link: "/vlog",
  },
  {
    title: "Playlist",
    link: "/vlog/playlist",
  },
];

export const VlogAllPlaylist = ({ vlogPlaylist }) => {
  const router = useRouter();

  const [paginate, setPaginate] = useState({
    currentPage: vlogPlaylist.currentPage,
    limit: vlogPlaylist.limit,
    page_total: vlogPlaylist.page_total,
    total: vlogPlaylist.total,
  });

  useEffect(() => {
    if (vlogPlaylist.currentPage) {
      setPaginate((prev) => ({
        ...prev,
        currentPage: vlogPlaylist.currentPage,
      }));
    }
  }, [vlogPlaylist.currentPage]);

  const paginationHandler = (e, page) => {
    e.preventDefault();
    router.push(`/vlog/playlist?limit=24&page=${page}`);
  };
  return (
    <Fragment>
      <VlogSectionHeading
        links={links}
        title={`Playlist (${vlogPlaylist?.total}+ Videos)`}
      />
      <section>
        <div className="container">
          <Grid container spacing={4}>
            {vlogPlaylist &&
              vlogPlaylist?.results?.length > 0 &&
              vlogPlaylist?.results?.map((item, i) => (
                <Grid item xl={3} lg={3} md={4} sm={6} xs={12} key={i}>
                  <VlogPlaylistCard item={item} />
                </Grid>
              ))}
          </Grid>
          {paginate && paginate.total > paginate.limit && (
            <PaginationComponent
              paginate={paginate}
              paginationHandler={paginationHandler}
            />
          )}
        </div>
      </section>
    </Fragment>
  );
};

export default VlogAllPlaylist;
